import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div className="container-jcc py-24 max-w-xl text-center" data-testid="page-checkout-cancel">
      <AlertTriangle className="w-12 h-12 mx-auto text-amber-500" />
      <h1 className="mt-4 font-display text-3xl font-bold">Checkout cancelled.</h1>
      <p className="mt-2 text-ink-muted">No charge was made. You can try again whenever you're ready.</p>
      <div className="mt-6 flex justify-center gap-3">
        <Link to="/pro-carer-circle" className="btn-purple">Back to Pro Carer Office</Link>
        <Link to="/family-access" className="btn-outline">Family Care Office</Link>
      </div>
    </div>
  );
}
